module.exports = __webpack_public_path__ + "static/media/2.f7d3052f.jpg";